var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "https://www.w3.org/2000/svg",
    width: 38.891,
    height: 38.891,
    viewBox: "0 0 38.891 38.891",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close_x",
    "data-name": "close x",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M13.375,27.5a1.5,1.5,0,0,1-1.5-1.5V15.625H1.5a1.5,1.5,0,0,1-1.5-1.5v-.75a1.5,1.5,0,0,1,1.5-1.5H11.875V1.5a1.5,1.5,0,0,1,1.5-1.5h.75a1.5,1.5,0,0,1,1.5,1.5V11.875H26a1.5,1.5,0,0,1,1.5,1.5v.75a1.5,1.5,0,0,1-1.5,1.5H15.625V26a1.5,1.5,0,0,1-1.5,1.5Z",
    transform: "translate(19.445 0) rotate(45)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteClose);
export default __webpack_public_path__ + "static/media/white-close.e088e2e48a6a95d5998ab0ebe2afe121.svg";
export { ForwardRef as ReactComponent };